export enum CustomerOrderStatus
{
    Pending = 0,
    Confirm = 1,
    Dispatched = 2,
    Delivered = 3
}